module.exports = __webpack_public_path__ + "static/media/wisdom-aura.74ca098a.png";